/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

export const BASE_COLOR = '#a4cea0', CONTRAST_COLOR = '#3a4044';

export const CITIES: string[] = [
    // 'Amstelhoek',
    // 'Baambrugge',
    // 'De Hoef',
    'Mijdrecht',
    'Vinkeveen',
    'Waverveen',
    'Wilnis',
];

export function formatCitiesString(): string {
    return CITIES.slice(0, CITIES.length - 1).join(', ') + ` en ${CITIES[CITIES.length - 1]}`;
}